<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="UID" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入UID"></el-input>
					</el-form-item>
					<el-form-item label="用户名" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<el-form-item label="用户电话" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入用户电话"></el-input>
					</el-form-item>
					<el-form-item label="预约状态" class='tiny'>
						<el-select v-model="searchInfo.status" class="big" placeholder="请选择预约状态" clear>
							<el-option :key="0" label="已预约" :value="0">已预约</el-option>
							<el-option :key="1" label="已完成" :value="1">已完成</el-option>
							<el-option :key="2" label="已取消" :value="2">已取消</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否被选为必中" class='tiny'>
						<el-select  v-model="searchInfo.isCheck" class="big" placeholder="请选择" clear>
							<el-option :key="0" label="是" :value="true">是</el-option>
							<el-option :key="1" label="否" :value="false">否</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="预约总金额">
						<span>{{subtatol}}元</span>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="setplace">设置必中</el-button>
							<el-button type="primary" @click="calplace">取消必中</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="schedulingData.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="userId" label="UID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="username" label="用户名" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="用户电话" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="subscribeAmount" label="预约金额" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="createTime" label="预约时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="预约状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.status == 0">已预约</div>
					<div v-if="scope.row.status == 1">已完成</div>
					<div v-if="scope.row.status == 2">已取消</div>
				</template>
			</el-table-column>
			<el-table-column prop="isCheck" label="是否被选为必中"  align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.isCheck == true">是</div>
					<div v-if="scope.row.isCheck == false">否</div>
				</template>
			</el-table-column>
			<el-table-column prop="pairTime" label="预约匹配成功时间"  align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<!-- <el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">编辑</el-button>　　
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id,1)"
								v-if="scope.row.status==0 && scope.row.status==0">启售</el-dropdown-item>
							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id,2)"
								v-if="scope.row.status==1 && scope.row.status==1" style="color: red;">停售</el-dropdown-item>
							<el-dropdown-item @click.native="toDelete(scope.row)">删除</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>　　
				</template>　
			</el-table-column> -->
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="schedulingData.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="schedulingData.total"
			@size-change="handleSizeChange">
		</el-pagination>
		
		
		<el-dialog title="设置必中" :visible.sync="resertionVisible" width="70%" :close-on-click-modal="false">
			
				<el-form :inline="true" :model="ationFrom" size="medium" width="70%" :close-on-click-modal="false">
					<el-form-item label="UID" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="ationFrom.userId" placeholder="请输入UID"></el-input>
					</el-form-item>
					<el-form-item label="用户名" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="ationFrom.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<el-form-item label="用户电话" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="ationFrom.phone" placeholder="请输入用户电话"></el-input>
					</el-form-item>
					
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
						<el-button @click="onembty">清空</el-button>
					</el-form-item>
				</el-form>
				<el-table ref="resert" :data="schedData.list" border height="450" style="width: 100%;" 
				:header-cell-style="headClass" v-loading="loading"
					element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" :row-key="getRowKey" 
					 @selection-change="handleStaffChange">
					<el-table-column type="selection" align="center" :reserve-selection="true"
						width="55">
						<!-- <template slot-scope="scope">
						        <el-checkbox v-model="scope.row.isCheck" @change="handleCheckboxChange(scope.row)" ></el-checkbox>
						</template> -->
					</el-table-column>
					<el-table-column prop="userId" label="UID" align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="username" label="用户名" align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="phone" label="用户电话" align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="subscribeAmount" label="预约金额" align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="createTime" label="预约时间" align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="status" label="预约状态" align="center" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div v-if="scope.row.status == 0">已预约</div>
							<div v-if="scope.row.status == 1">已完成</div>
							<div v-if="scope.row.status == 2">已取消</div>
						</template>
					</el-table-column>
					<el-table-column prop="isCheck" label="是否被选为必中"  align="center" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div v-if="scope.row.isCheck == true">是</div>
							<div v-if="scope.row.isCheck == false">否</div>
						</template>
					</el-table-column>
					</el-table>
						<div style="padding-top: 20px;">预约总金额{{sum}}元</div>
					<el-pagination style="margin: 20px 0px 20px;" background :current-page="schedData.pageNum"
						@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
						:total="schedData.total" @size-change="handleSizeChange">
					</el-pagination>
					<div style="text-align: center;margin-top: 30px">
						<el-button @click="resertionVisible = false">取 消</el-button>
						<el-button v-if="this.nowTime < this.limtInfo.qdBegin && this.nowTime > this.limtInfo.subEnd " type="primary" @click="sure">确 认</el-button>
						<el-button v-else type="primary" disabled @click="sure">不在设置时间内</el-button>
					</div>
			
		</el-dialog>
		
		<el-dialog title="取消必中" :visible.sync="cancelVisible" width="70%" :close-on-click-modal="false">
			<el-form :inline="true" :model="ationFrom" size="medium" width="70%" :close-on-click-modal="false">
				<el-form-item label="UID" class='tiny' cleartable>
					<el-input style="width: 200px;" v-model="ationFrom.userId" placeholder="请输入UID"></el-input>
				</el-form-item>
				<el-form-item label="用户名" class='tiny' cleartable>
					<el-input style="width: 200px;" v-model="ationFrom.username" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="用户电话" class='tiny' cleartable>
					<el-input style="width: 200px;" v-model="ationFrom.phone" placeholder="请输入用户电话"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit">查询</el-button>
					<el-button @click="onembty">清空</el-button>
				</el-form-item>
			</el-form>
			<el-table ref="caul" :data="caulData.list" border height="450" style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
				element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" :row-key="getCauKey"
				 @selection-change="cauChange">
				<el-table-column type="selection" align="center" :reserve-selection="true"
					width="55">
					<!-- <template slot-scope="scope">
					        <el-checkbox v-model="scope.row.isCheck" @change="caulCheckboxChange(scope.row)" ></el-checkbox>
					</template> -->
				</el-table-column>
				<el-table-column prop="userId" label="UID" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="username" label="用户名" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="phone" label="用户电话" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="subscribeAmount" label="预约金额" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="status" label="预约状态" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div v-if="scope.row.status == 0">已预约</div>
						<div v-if="scope.row.status == 1">已完成</div>
						<div v-if="scope.row.status == 2">已取消</div>
					</template>
				</el-table-column>
				<el-table-column prop="isCheck" label="是否被选为必中"  align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div v-if="scope.row.isCheck == true">是</div>
						<div v-if="scope.row.isCheck == false">否</div>
					</template>
				</el-table-column>
			</el-table>
		
			<el-pagination style="margin: 20px 0px 20px;" background :current-page="caulData.pageNum"
				@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
				:total="caulData.total" @size-change="handleSizeChange">
			</el-pagination>
			<div style="text-align: center;margin-top: 30px">
				<el-button @click="cancelVisible = false">取 消</el-button>
				<el-button type="primary" v-if="this.nowTime < this.limtInfo.qdBegin && this.nowTime > this.limtInfo.subEnd " @click="sure2">确 认</el-button>
				<el-button type="primary" v-else disabled>不在设置时间内</el-button>
			</div>
		</el-dialog>
		
		
	</div>
</template>

<script>
	export default {
		data() {
			return{
				searchInfo:{},
				loading: false,
				page: {
					pageNum: 1,
					pageSize: 10
				},
				schedulingData:{},
				resertionVisible:false,
				cancelVisible:false,
				ationFrom:{},
				mupSelection:[],
				schedData:{},
				setId:[],
				caulData:{},
				cauSelection:[],
				limtInfo:{},
				nowTime:'',
				subtatol:'',
				sum:0
			}
		},
		methods:{
			// 查询
			search(){
				this.page.pageNum = 1;
				this.getSubscrList()
			},
			// 清空
			empty(){
				this.searchInfo = {}
			},
			//设置必中按钮
			setplace(){
				this.schedData.list = []
				this.getSubscrList0()
				setTimeout(() => {
					this.$refs.resert.clearSelection();
				
				}, 0);
				// console.log(222);
				this.setId = []
				this.mupSelection = []
				this.resertionVisible = true
			},
			//设置必中确定
			sure(){
				this.mupSelection.map(item=>{
					this.setId.push(item.id)
				})
				// console.log(this.setId);
				let data = {
					ids:this.setId.join(','),
					type:1
				}
				// console.log(data);
				this.$api.setCaul(this.$encrypt(data)).then(res=>{
					// console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getSubscrList()
						this.resertionVisible = false
						this.setId = []
		
					}else{
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
				})
			},
			// 弹窗内表格查询
			onSubmit(){
				this.page.pageNum = 1;
				this.getSubscrList0()
				this.getSubscrList1()
			},
			// 弹窗内表格清空
			onembty(){
				this.ationFrom = {}
			},
			getRowKey(row){
				return row.id;
			},
			getCauKey(row){
				return row.id;
			},
			handleStaffChange(row){
				// console.log(row);
				this.sum=0
				this.mupSelection = row
				for (let i = 0; i < row.length; i++) {
					// console.log( row[i].subscribeAmount);
				  this.sum += row[i].subscribeAmount;
				}
				
			},
			cauChange(row){
				this.cauSelection = row
				// console.log(this.cauSelection);
			},
			// 取消必中
			calplace(){
				// console.log(111);
				this.caulData.list = []
				this.getSubscrList1()
				setTimeout(() => {
					this.$refs.caul.clearSelection();
				}, 0);
				this.setId = []
				this.cauSelection = []
				this.cancelVisible = true
			},
			// 取消必中确定
			sure2(){
				this.cauSelection.map(item=>{
					this.setId.push(item.id)
				})
				// console.log(this.setId);
				let data = {
					ids:this.setId.join(','),
					type:0
				}
				this.$api.setCaul(this.$encrypt(data)).then(res=>{
					// console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getSubscrList()
						this.cancelVisible = false
						this.setId = []
						
						
					}else{
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
				})
			},
			//分页
			pageChange(data) {
				this.page.pageNum = data
				this.getSubscrList()
				this.getSubscrList0()
				this.getSubscrList1()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getSubscrList()
				this.getSubscrList0()
				this.getSubscrList1()
			},
			// 预约排单列表
			getSubscrList(){
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					...this.searchInfo
				}
				this.$api.subscrList(this.$encrypt(data)).then(res=>{
					
					res=JSON.parse(this.$decrypt(res.data))
					
					if(res.state == 'success'){
						this.schedulingData = res.data
					}else{
						this.$message.error(res.message);
					}
				})
				this.$api.SubscribeTotal(this.$encrypt(data)).then(res=>{
					this.subtatol=res.data
				})
			},
			//设置必中满足条件信息列表
			getSubscrList0(){
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					status:0,
					isCheck:0,
					...this.ationFrom
				}
				this.$api.subscrList(this.$encrypt(data)).then(res=>{
					
					res=JSON.parse(this.$decrypt(res.data))
				
					if(res.state == 'success'){
						this.schedData = res.data
						// console.log(this.schedData);
					}
				})
			},
			//取消必中满足条件信息列表
			getSubscrList1(){
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					status:0,
					isCheck:1,
					...this.ationFrom
				}
				this.$api.subscrList(this.$encrypt(data)).then(res=>{
					// console.log(res);
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						this.caulData = res.data
						// console.log(this.caulData);
					}
				})
			},
			
			getData(){
				const now = new Date();
				const hours = now.getHours().toString().padStart(2, '0'); // 将小时数转换为字符串，并保证是两位数，不足则在前面填充 0
				const minutes = now.getMinutes().toString().padStart(2, '0'); // 将分钟数转换为字符串，并保证是两位数，不足则在前面填充 0
				this.nowTime = `${hours}:${minutes}`;
				// console.log(this.nowTime);
			},
			
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
		},
		created() {
			this.getSubscrList()
			this.getData()
			this.$api.byKey({key:'SubsParameter'}).then(res=>{
				res=JSON.parse(this.$decrypt(res.data))
				// console.log(res);
				if(res.state == 'success'){
					this.limtInfo =JSON.parse(res.data.settingValue) 
					// console.log(this.limtInfo);
				}
			})
		}
	}
</script>

<style>
	
</style>